import { Maybe } from '../../../__generated__/globalTypes'

import userSettingsFragmentRawString from '../UserSettingsFragment.graphql'

export const userSettingsFragmentString = userSettingsFragmentRawString

export type UserSettingsFragment = {
  defaultBackPanel: Maybe<{
    id: string
  }>
  receivesPromoEmails: boolean
  receivesNotificationEmails: boolean
  receivesReceiptEmails: boolean
  receivesReminderEmails: boolean
  printRecipientCompany: boolean
}

export const isUserSettingsFragment = (
  fragment: any,
): fragment is UserSettingsFragment =>
  fragment &&
  (fragment.defaultBackPanel === null ||
    (fragment.defaultBackPanel &&
      typeof fragment.defaultBackPanel.id === 'string')) &&
  typeof fragment.receivesPromoEmails === 'boolean' &&
  typeof fragment.receivesNotificationEmails === 'boolean' &&
  typeof fragment.receivesReceiptEmails === 'boolean' &&
  typeof fragment.receivesReminderEmails === 'boolean' &&
  typeof fragment.printRecipientCompany === 'boolean'
